<template>
  <div class="w-full flex flex-col gap-2">
    <sc-link :field="fields.internalLink" class="block w-full">
      <div class="gold-border-wrapper p-[3px]!">
        <div
          class="rounded-xl relative w-full h-[100px] flex items-center justify-center overflow-hidden"
        >
          <!-- blurred background image -->
          <sc-image
            :media="fields.image"
            class="absolute inset-0 w-full h-full object-cover filter blur-[1px] z-0"
          />

          <!-- translucent white gradient overlay from left -->
          <div
            class="absolute inset-0 z-10 pointer-events-none banner-gradient"
            aria-hidden="true"
          />

          <!-- title/text on top -->
          <span
            class="text-white text-3xl font-serif font-bold absolute inset-0 w-full h-full flex items-center justify-start px-4 z-20"
          >
            <sc-text :field="fields.title" class="title" />
          </span>
        </div>
      </div>
    </sc-link>

    <div class="flex items-center">
      <div class="px-2">
        <sc-text :field="fields.text" class="text-2xl/5 font-semibold" v-if="fields.text" />
        <p class="text-base font-bold lh-base"><sc-text :field="fields.subText" /></p>
      </div>
    </div>
  </div>
</template>

<script>
import { Image as ScImage, Text as ScText, Link as ScLink } from '@sitecore-jss/sitecore-jss-vue';
export default {
  name: 'PagePreview',
  props: {
    rendering: {
      type: Object,
      required: true,
    },
  },
  components: {
    'sc-image': ScImage,
    'sc-text': ScText,
    'sc-link': ScLink,
    //'sc-subtext': ScSubText,
  },
  computed: {
    fields() {
      // rendering.fields are populated from route YAML (disconnected)
      // or from Layout Service (integrated)
      return this.rendering?.fields || {};
    },
    imageUrl() {
      const img = this.fields?.image || {};
      // try common shapes used by disconnected/layout service
      return img.src || (img.value && img.value.src) || (img.fields && img.fields.src) || '';
    },
  },
};
</script>
<style scoped>
    .banner-gradient {
        background: linear-gradient(149deg,rgba(64, 104, 169, 1) 0%, rgba(0, 54, 140, 1) 22%, rgba(1, 17, 47, 0.4) 80%);
        background-repeat: no-repeat;
        background-size: cover;
    }

.title {
  text-shadow:
    0 0 8px rgba(1, 17, 47, 0.5),
    0 0 16px #01112f;
}
</style>
